import { DB } from "./deviceStorage";
import { pullGlobal, pushGlobal } from "../sync/collectionApi";
import { SYSTEM_LISTS_DEFAULTS } from "./globals";
import { SYSTEM_LISTS_KEY, SYSTEM_LISTS_GLOBAL_KEY, normalizeSystemListsPayload } from "./systemListsUtils";

async function loadLocalSystemLists() {
  try {
    const saved = await DB.get(SYSTEM_LISTS_KEY);
    if (saved && typeof saved === "object") {
      return normalizeSystemListsPayload(saved);
    }
  } catch(e){}
  return { ...SYSTEM_LISTS_DEFAULTS };
}

async function syncSystemListsFromServer(userName = "system-lists") {
  if (!navigator.onLine) return loadLocalSystemLists();
  try {
    const srv = await pullGlobal(SYSTEM_LISTS_GLOBAL_KEY, userName);
    const srvData = srv?.data && typeof srv.data === "object" && !Array.isArray(srv.data)
      ? normalizeSystemListsPayload(srv.data)
      : null;
    const srvVer = Number(srv?.version || 0);
    const locVer = Number((await DB.get(`${SYSTEM_LISTS_GLOBAL_KEY}:_ver`)) || 0);
    const local = await loadLocalSystemLists();
    if (srvData && srvVer > locVer) {
      await DB.set(SYSTEM_LISTS_KEY, srvData);
      await DB.set(SYSTEM_LISTS_GLOBAL_KEY, srvData);
      await DB.set(`${SYSTEM_LISTS_GLOBAL_KEY}:_ver`, srvVer);
      return srvData;
    }
    if ((!srvData || srvVer === 0) && local && typeof local === "object") {
      const res = await pushGlobal(SYSTEM_LISTS_GLOBAL_KEY, local, userName);
      if (res?.version) {
        await DB.set(`${SYSTEM_LISTS_GLOBAL_KEY}:_ver`, res.version);
      }
    }
    return local;
  } catch(e) {
    return loadLocalSystemLists();
  }
}

async function getSystemLists() {
  const local = await loadLocalSystemLists();
  if (!navigator.onLine) return local;
  return await syncSystemListsFromServer("system-lists-load");
}

async function saveSystemLists(lists) {
  const normalized = normalizeSystemListsPayload(lists);
  await DB.set(SYSTEM_LISTS_KEY, normalized);
  await DB.set(SYSTEM_LISTS_GLOBAL_KEY, normalized);
  window.dispatchEvent(new CustomEvent("fz:systemlists:updated"));
  if (navigator.onLine) {
    try {
      const res = await pushGlobal(SYSTEM_LISTS_GLOBAL_KEY, normalized, "system-lists-save");
      if (res?.version) {
        await DB.set(`${SYSTEM_LISTS_GLOBAL_KEY}:_ver`, res.version);
      }
    } catch(e) {}
  }
}

export { loadLocalSystemLists, syncSystemListsFromServer, getSystemLists, saveSystemLists };
